import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginLayoutComponent } from './login-layout/login-layout.component';
import { LoginComponent } from './pages/login/login.component';
import { LogoutComponent } from './pages/logout/logout.component';
import { PasswordResetComponent } from './pages/password-reset/password-reset.component';
import { WaitPageComponent } from './pages/wait-page/wait-page.component';
import { VerifyEmailComponent } from './pages/verify-email/verify-email.component';
import { MfaChallengeComponent } from './pages/mfa-challenge/mfa-challenge.component';
import { EnrollMfaComponent } from './pages/enroll-mfa/enroll-mfa.component';
import { AuthActionComponent } from './pages/auth-action/auth-action.component';
import { captureReturnUrlGuard } from '@core/guards/capture-return-url.guard';
import { redirectToQuickRegister } from '@core/guards/quick-register-redirect.guard';

const routes: Routes = [
  {
    path: '',
    component: LoginLayoutComponent,
    canActivate: [captureReturnUrlGuard],
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'register',
        loadChildren: () =>
          import('./pages/sign-up/sign-up.module').then((m) => m.SignUpModule),
      },
      {
        // Common guesses at the signup URL. Forwarded, query string and all,
        // to the one registration entry point (#943).
        path: 'signup',
        pathMatch: 'full',
        redirectTo: redirectToQuickRegister,
      },
      {
        path: 'sign-up',
        pathMatch: 'full',
        redirectTo: redirectToQuickRegister,
      },
      {
        path: 'logout',
        component: LogoutComponent,
      },
      {
        path: 'reset-password',
        component: PasswordResetComponent,
      },
      {
        path: 'logging-in',
        component: WaitPageComponent,
      },
      {
        // Reachable by authenticated-but-unverified users. Since #943 nothing
        // redirects here at sign-in; invite redemption still sends an
        // unverified invitee here, because redeeming needs a verified address.
        path: 'verify-email',
        component: VerifyEmailComponent,
      },
      {
        // Second-factor step of sign-in. The user is NOT authenticated yet —
        // AuthService stashes a MultiFactorResolver and navigates here; the
        // page redirects to /login when no resolver is present.
        path: 'mfa-challenge',
        component: MfaChallengeComponent,
      },
      {
        // Forced/prompted MFA enrollment for signed-in users. Intentionally
        // NOT behind adminAuthGuard: mfaEnrolledGuard (mode 'required')
        // redirects here, and guarding it would create a redirect loop.
        path: 'enroll-mfa',
        component: EnrollMfaComponent,
      },
      {
        // Handler for links in Firebase Authentication emails (verify email,
        // reset password, recover/change email) (#835). Public: the person
        // following the link is usually not signed in.
        path: 'auth/action',
        component: AuthActionComponent,
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginRoutingModule {}
